import * as ReactDOM from 'react-dom/client';

import { initializeAPM } from '@zeta-commons';
import { i18n } from '@zeta-core';
import App from './app/app';
import './styles.css';

// Initialize APM as early as possible
initializeAPM();
void i18n;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
